<template>
  <div id='app'>
    <router-view></router-view>
  </div>
</template>
<script>
import { Message } from 'element-ui';
import router from './router';

export default {

  created() {

    this.$router.beforeEach((to, from, next) => {
      var routearr = localStorage.getItem('routearr');

      if (to.path == '/login' || from.path == '/login' ) {
        next();
      } else {
        var useropj = localStorage.getItem('useropj');
        if (!useropj) {
          console.log(this.$route.path);
          localStorage.clear();
          router.push('/login');
        }
        console.log(to.meta.roles[0]);
        if ((routearr.indexOf(to.meta.roles[0])) == -1) {
          next(from.path);
        } else {
          next();
        }
      }
    });


  }
};
</script>
<style lang='less'>

@import "./assets/css/flexall.less";
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css"; /*深色主题*/
/*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>